(() => {
  function initialize(root = document) {
    root.querySelectorAll('[data-shop-product]').forEach(section => {
      const select = section.querySelector('[data-shop-variant]');
      if (!select || select.dataset.initialized) return;
      select.dataset.initialized = 'true';
      const plan = section.querySelector('[data-shop-plan]');
      function updatePrice() {
        const variant = select.selectedOptions[0];
        const allocation = plan?.selectedOptions[0];
        const priceSource = allocation?.value ? allocation : variant;
        section.querySelector('[data-shop-price]').textContent = priceSource.dataset.price;
        const compare = section.querySelector('[data-shop-compare]');
        compare.textContent = priceSource.dataset.compare;
        compare.hidden = !priceSource.dataset.compare;
        const available = variant.dataset.available === 'true' && (section.dataset.requiresPlan !== 'true' || Boolean(allocation?.value));
        const button = section.querySelector('[data-shop-add]');
        button.disabled = !available;
        button.dataset.priceCents = priceSource.dataset.cents || '0';
        button.dataset.available = String(available);
        section.dispatchEvent(new CustomEvent('sv:update', { bubbles: true }));
      }
      plan?.addEventListener('change', updatePrice);
      select.addEventListener('change', () => {
        const option = select.selectedOptions[0];
        if (plan) {
          const previous = plan.value;
          const template = section.querySelector(`[data-shop-plans="${option.value}"]`);
          plan.replaceChildren(template.content.cloneNode(true));
          if (Array.from(plan.options).some(option => option.value === previous)) plan.value = previous;
          section.querySelector('[data-shop-plan-field]').hidden = plan.options.length === 0;
        }
        updatePrice();
        const quantity = section.querySelector('[data-shop-quantity]');
        quantity.min = option.dataset.min || '1';
        quantity.step = option.dataset.step || '1';
        if (option.dataset.max) quantity.max = option.dataset.max;
        else quantity.removeAttribute('max');
        quantity.value = quantity.min;
        const url = new URL(window.location.href);
        url.searchParams.set('variant', option.value);
        window.history.replaceState({}, '', url);
        section.dispatchEvent(new CustomEvent('sv:update', { bubbles: true }));
      });
      updatePrice();
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialize());
  else initialize();
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();
